import { useState } from 'react';
import { Globe, Check } from 'lucide-react';
import { useTranslation, SUPPORTED_LANGUAGES } from '@/i18n/LanguageContext';

export default function LanguageSwitcher({ variant = 'pill', className = '' }) {
  const { lang, setLang } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === lang) || SUPPORTED_LANGUAGES[0];

  return (
    <div className={`relative ${className}`} data-testid="language-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="language-switcher-trigger"
        className={`flex items-center gap-1.5 transition-colors ${
          variant === 'pill'
            ? 'px-3 py-1.5 rounded-full border border-white/15 hover:border-[#DC2626]/50 bg-black/40 text-[#A3A3A3] hover:text-[#F5F5F5] text-[10px] tracking-[0.25em] uppercase'
            : 'text-[#A3A3A3] hover:text-[#F5F5F5] text-xs'
        }`}
      >
        <Globe size={12} />
        <span className="font-medium">{current.short}</span>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 z-50 w-44 rounded-xl border border-white/10 bg-[#0A0505] shadow-2xl overflow-hidden">
            {SUPPORTED_LANGUAGES.map((l) => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                data-testid={`lang-option-${l.code}`}
                className={`w-full flex items-center justify-between px-4 py-2.5 text-sm hover:bg-white/5 transition-colors ${
                  l.code === lang ? 'text-[#DC2626]' : 'text-[#F5F5F5]'
                }`}
              >
                <span className="flex items-center gap-2">
                  <span className="text-[10px] uppercase tracking-wider text-[#A3A3A3] w-6">{l.short}</span>
                  {l.label}
                </span>
                {l.code === lang && <Check size={14} />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
